// Aviso em tela cheia da programação do cliente — coletado por glob em core/i18n/messages.ts.
export default {
  pt: {
    'layout.avisoProgramacao.nova': 'Chegou programação nova',
    'layout.avisoProgramacao.reprogramada': 'Programação reprogramada',
    'layout.avisoProgramacao.varias': 'Chegaram {{n}} programações',
    'layout.avisoProgramacao.subtitulo': 'O cliente programou pelo Hub. Confira e dê ciente para a sua dupla.',
    'layout.avisoProgramacao.tipoNova': 'Nova',
    'layout.avisoProgramacao.tipoReprogramacao': 'Reprogramação',
    'layout.avisoProgramacao.por': 'Por {{quem}}',
    'layout.avisoProgramacao.antes': 'Antes',
    'layout.avisoProgramacao.agora': 'Agora',
    'layout.avisoProgramacao.horarios': 'Horários',
    'layout.avisoProgramacao.cargas': '{{n}} cargas',
    'layout.avisoProgramacao.umaCarga': '1 carga',
    'layout.avisoProgramacao.fazenda': 'Fazenda',
    'layout.avisoProgramacao.destino': 'Destino',
    'layout.avisoProgramacao.semDupla': 'Contrato sem dupla',
    'layout.avisoProgramacao.ciente': 'Ciente',
    'layout.avisoProgramacao.cienteTodas': 'Ciente de todas',
    'layout.avisoProgramacao.abrirFrente': 'Abrir a Frente de Trabalho',
  },
  en: {
    'layout.avisoProgramacao.nova': 'New schedule arrived',
    'layout.avisoProgramacao.reprogramada': 'Schedule changed',
    'layout.avisoProgramacao.varias': '{{n}} schedules arrived',
    'layout.avisoProgramacao.subtitulo': 'The customer scheduled through the Hub. Check it and acknowledge for your team.',
    'layout.avisoProgramacao.tipoNova': 'New',
    'layout.avisoProgramacao.tipoReprogramacao': 'Reschedule',
    'layout.avisoProgramacao.por': 'By {{quem}}',
    'layout.avisoProgramacao.antes': 'Before',
    'layout.avisoProgramacao.agora': 'Now',
    'layout.avisoProgramacao.horarios': 'Times',
    'layout.avisoProgramacao.cargas': '{{n}} loads',
    'layout.avisoProgramacao.umaCarga': '1 load',
    'layout.avisoProgramacao.fazenda': 'Farm',
    'layout.avisoProgramacao.destino': 'Destination',
    'layout.avisoProgramacao.semDupla': 'Contract without team',
    'layout.avisoProgramacao.ciente': 'Acknowledge',
    'layout.avisoProgramacao.cienteTodas': 'Acknowledge all',
    'layout.avisoProgramacao.abrirFrente': 'Open the Work Front',
  },
  es: {
    'layout.avisoProgramacao.nova': 'Llegó una programación nueva',
    'layout.avisoProgramacao.reprogramada': 'Programación reprogramada',
    'layout.avisoProgramacao.varias': 'Llegaron {{n}} programaciones',
    'layout.avisoProgramacao.subtitulo': 'El cliente programó por el Hub. Revise y confirme para su dupla.',
    'layout.avisoProgramacao.tipoNova': 'Nueva',
    'layout.avisoProgramacao.tipoReprogramacao': 'Reprogramación',
    'layout.avisoProgramacao.por': 'Por {{quem}}',
    'layout.avisoProgramacao.antes': 'Antes',
    'layout.avisoProgramacao.agora': 'Ahora',
    'layout.avisoProgramacao.horarios': 'Horarios',
    'layout.avisoProgramacao.cargas': '{{n}} cargas',
    'layout.avisoProgramacao.umaCarga': '1 carga',
    'layout.avisoProgramacao.fazenda': 'Hacienda',
    'layout.avisoProgramacao.destino': 'Destino',
    'layout.avisoProgramacao.semDupla': 'Contrato sin dupla',
    'layout.avisoProgramacao.ciente': 'Visto',
    'layout.avisoProgramacao.cienteTodas': 'Visto en todas',
    'layout.avisoProgramacao.abrirFrente': 'Abrir el Frente de Trabajo',
  },
}
